var _g, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaymentSuccessfulIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 45C0 20.1472 20.1472 0 45 0C69.8528 0 90 20.1472 90 45C90 69.8528 69.8528 90 45 90C20.1472 90 0 69.8528 0 45Z",
    fill: "#CDF9F1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "#CDF9F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 64.5C56.0457 64.5 65 55.5457 65 44.5C65 33.4543 56.0457 24.5 45 24.5C33.9543 24.5 25 33.4543 25 44.5C25 55.5457 33.9543 64.5 45 64.5ZM54.184 39.421C54.6926 38.7671 54.5748 37.8246 53.9209 37.316C53.267 36.8074 52.3246 36.9252 51.816 37.5792L43.802 47.8829C43.6238 48.112 43.2886 48.1417 43.0728 47.9476L38.0035 43.3851C37.3877 42.8309 36.4393 42.8809 35.8851 43.4966C35.3309 44.1124 35.3808 45.0608 35.9966 45.615L41.0659 50.1774C42.5762 51.5367 44.9226 51.3285 46.17 49.7247L54.184 39.421Z",
    fill: "#00D694"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaymentSuccessfulIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/payment_successful_icon.04059846934c555d04dec2df9ab97d8d.svg";